import SelectBox from "devextreme-react/select-box";
import React, { useEffect, useState } from 'react';
import { emailTemplateApi } from '../../api/emailTemplateApi';
import { useCommonContext } from '../../contexts/common';

const SelectBoxEmailTemplate = ({
    value,
    onValueChanged,
    showClearButton,
    widthCustom, dm_coso_id, onValueChangedWithBody,
    disabled
}) => {
    const { translate } = useCommonContext();
    const [email_templates, set_email_templates] = useState([]);
    useEffect(() => {
        (async () => {
            onValueChanged && onValueChanged([]);
            onValueChangedWithBody && onValueChangedWithBody(null);
            const res = await emailTemplateApi.SelectByCoSo(dm_coso_id);
            if (res.is_success) {
                set_email_templates(res.data);
            } else {
                set_email_templates([]);
            }
        })();
    }, []);
    const containerStyle = {
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
    };

    return (
        <div
            style={containerStyle}
        >
            <SelectBox
                items={email_templates}
                showSelectionControls={false}
                searchEnabled={true}
                displayExpr={'name'}
                valueExpr={'id'}
                value={value}
                disabled={disabled}
                multiline={false}
                stylingMode="outlined"
                width={widthCustom}
                placeholder={translate('Chọn mẫu email')}
                showClearButton={showClearButton}
                height={'auto'}
                onValueChanged={(e) => {
                    onValueChanged && onValueChanged(e.value);
                    const email = email_templates.find((val) => val.id = e.value)

                    onValueChangedWithBody && onValueChangedWithBody(email);
                }}
            />
        </div>
    );
};

export default SelectBoxEmailTemplate;
